import { motion } from "framer-motion";
import {
  ShoppingBasket,
  Sparkle,
  Baby,
  CupSoda,
  Flame,
  PawPrint,
  CookingPot,
  Cookie,
} from "lucide-react";
import { Reveal } from "./Reveal";

const categories = [
  { icon: ShoppingBasket, label: "Grocery & Staple" },
  { icon: Sparkle, label: "Personal Care" },
  { icon: Baby, label: "Baby Care" },
  { icon: CupSoda, label: "Beverages" },
  { icon: Flame, label: "Pooja Needs" },
  { icon: PawPrint, label: "Pet Care" },
  { icon: CookingPot, label: "Home & Kitchen" },
  { icon: Cookie, label: "Snacks & Treats" },
];

export const Essentials = () => {
  return (
    <section
      data-testid="essentials-section"
      className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 md:py-32"
    >
      <div className="max-w-2xl">
        <Reveal>
          <p className="mb-6 text-xs uppercase tracking-[0.3em] text-brand-volt">Categories</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display text-6xl uppercase leading-[0.9] tracking-tight md:text-7xl">
            Daily essentials
            <br />
            you&apos;ll always <span className="font-serif italic lowercase text-brand-volt">love.</span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-12 flex flex-wrap gap-3">
        {categories.map((c, i) => (
          <Reveal key={c.label} delay={i * 0.04} y={20}>
            <motion.button
              data-testid={`category-${i}`}
              whileHover={{ y: -4 }}
              transition={{ type: "spring", stiffness: 400, damping: 20 }}
              className="group flex items-center gap-2.5 rounded-full border border-brand-line bg-brand-surface px-5 py-3 text-sm text-brand-bone transition-colors duration-300 hover:border-brand-volt hover:bg-brand-elevated"
            >
              <c.icon size={16} className="text-brand-volt" />
              {c.label}
            </motion.button>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
